export default "__VITE_ASSET__QKBFQnbO__"